import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-ot',
  templateUrl: './events-ot.component.html',
  styleUrls: ['./events-ot.component.scss'],
})
export class EventsOtComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/ot/1.jpg',
      thumbnail: 'assets/img/school/events/ot/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/2.jpg',
      thumbnail: 'assets/img/school/events/ot/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/3.jpg',
      thumbnail: 'assets/img/school/events/ot/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/4.jpg',
      thumbnail: 'assets/img/school/events/ot/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/5.jpg',
      thumbnail: 'assets/img/school/events/ot/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/6.jpg',
      thumbnail: 'assets/img/school/events/ot/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/7.jpg',
      thumbnail: 'assets/img/school/events/ot/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/8.jpg',
      thumbnail: 'assets/img/school/events/ot/8.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/9.jpg',
      thumbnail: 'assets/img/school/events/ot/9.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/10.jpg',
      thumbnail: 'assets/img/school/events/ot/10.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/11.jpg',
      thumbnail: 'assets/img/school/events/ot/11.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/12.jpg',
      thumbnail: 'assets/img/school/events/ot/12.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/13.jpg',
      thumbnail: 'assets/img/school/events/ot/13.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/14.jpg',
      thumbnail: 'assets/img/school/events/ot/14.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/11.jpg',
      thumbnail: 'assets/img/school/events/ot/11.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/15.jpg',
      thumbnail: 'assets/img/school/events/ot/15.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/16.jpg',
      thumbnail: 'assets/img/school/events/ot/16.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/17.jpg',
      thumbnail: 'assets/img/school/events/ot/17.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/18.jpg',
      thumbnail: 'assets/img/school/events/ot/18.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/19.jpg',
      thumbnail: 'assets/img/school/events/ot/19.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/20.jpg',
      thumbnail: 'assets/img/school/events/ot/20.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/21.jpg',
      thumbnail: 'assets/img/school/events/ot/21.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/22.jpg',
      thumbnail: 'assets/img/school/events/ot/22.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/ot/23.jpg',
      thumbnail: 'assets/img/school/events/ot/23.jpg',
      alt: 'Image 01',
    },
  ];
}
